import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import useQueryParams from "../../hooks/useQueryParams";
import { useAuth } from "../../contexts/AuthContext";
import { PageHeaderProvider } from "../../contexts/PageHeaderContext";
// import UpgradePlansModal from "../UpgradePlansModal";
import TimezoneModal from "../TimezoneModal";
import PaymentFailureModal from "../PaymentFailureModal";
import SubscriptionCancelledModal from "../SubscriptionCancelledModal";
const DashboardLayout = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  // const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [timezoneModalOpen, setTimezoneModalOpen] = useState(false);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const queryParams = useQueryParams();
  const isFromUseTemplate = queryParams.step === "isFromUseTemplate";
  const isConfigureDocument =
    location.pathname.includes("configure-document") ||
    isFromUseTemplate ||
    location.pathname.includes("self-sign");
  // const isNotPaymentSuccessPage = location.pathname.includes("payment/success");

  // const hasTrial = user?.isInTrial;
  // const trialRemainingDays = user?.trialDaysLeft;

  // const handleUpgradeClick = () => {
  //   setUpgradeModalOpen(true);
  // };

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.tidioChatApi) {
        window.tidioChatApi.hide(); // 👈 Hides the widget button
        clearInterval(interval);
      }
    }, 500);

    return () => {
      window.tidioChatApi.show();
    };
  }, []);

  const handleOpenTimezoneModal = () => {
    setTimezoneModalOpen(true);
  };

  useEffect(() => {
    if (isConfigureDocument && !isSidebarCollapsed) {
      setIsSidebarCollapsed(true);
      setIsCollapsed(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfigureDocument]);

  useEffect(() => {
    if (!isConfigureDocument) return undefined;
    const html = document.documentElement;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    html.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    return () => {
      html.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, [isConfigureDocument]);

  return (
    <div
      className={`bg-white ${
        isConfigureDocument
          ? "h-screen overflow-hidden min-h-0"
          : "min-h-screen"
      }`}
    >
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Mobile menu button */}
      <button
        className="fixed top-4 left-4 z-40 lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <span className="sr-only">Open sidebar</span>
        {sidebarOpen ? (
          <XMarkIcon className="h-6 w-6" />
        ) : (
          <Bars3Icon className="h-6 w-6" />
        )}
      </button>

      {/* Sidebar — fixed to left edge, full height */}
      <div
        className={`fixed top-0 left-0 bottom-0 z-30 transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-transform duration-200 ease-in-out`}
      >
        <Sidebar
          onCollapse={setIsSidebarCollapsed}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      </div>

      {/* Main content — offset by sidebar width */}
      <div
        className={`transition-all duration-300 ${
          isConfigureDocument
            ? "h-full min-h-0 flex flex-col overflow-hidden"
            : "min-h-screen"
        } ${isSidebarCollapsed ? "lg:pl-16" : "lg:pl-72"}`}
      >
        <PageHeaderProvider>
          {!isConfigureDocument && (
            <Navbar
              onOpenTimezoneModal={handleOpenTimezoneModal}
              isSidebarCollapsed={isSidebarCollapsed}
            />
          )}

          <main
            className={
              isConfigureDocument
                ? "flex-1 flex flex-col min-h-0 overflow-hidden box-border w-full"
                : ""
            }
            style={isConfigureDocument ? undefined : { paddingTop: "125px" }}
          >
            <Outlet />

            {/* {((hasTrial && trialRemainingDays <= 0) || !user?.isSubscribed) &&
            !isNotPaymentSuccessPage &&
            user?.company &&
            user?.company?.isSubscribed && (
              <div className="text-center text-red-500 fixed bottom-0 left-0 right-0 bg-white p-4 min-h-screen min-w-screen flex flex-col items-center justify-center z-50">
                {hasTrial && trialRemainingDays <= 0
                  ? "Your current plan has expired. Please upgrade to continue using the platform."
                  : "Your current plan has expired. Please upgrade to continue using the platform."}
                <button
                  onClick={handleUpgradeClick}
                  className="bg-primary text-white px-4 py-2 rounded-md mt-4 hover:bg-primary/90 transition-colors"
                >
                  Upgrade Now
                </button>
              </div>
            )} */}
          </main>
        </PageHeaderProvider>
      </div>

      {/* Upgrade Modal */}
      {/* <UpgradePlansModal
        isOpen={upgradeModalOpen}
        onClose={() => setUpgradeModalOpen(false)}
      /> */}

      {/* Timezone Modal */}
      <TimezoneModal
        isOpen={timezoneModalOpen}
        onClose={() => setTimezoneModalOpen(false)}
      />

      {/* Payment Failure Modal - Shows as full page when payment failed */}
      <PaymentFailureModal
        isOpen={user?.company?.isSubscribed && user?.company?.lastPaymentFailed}
        onClose={() => {}} // No close functionality since it's a blocking modal
      />

      {/* Subscription Cancelled Modal - Shows as full page only when subscription is actually cancelled */}
      <SubscriptionCancelledModal
        isOpen={
          user?.company?.isSubscribed && user?.company?.subscriptionCancelled
        }
        variant="cancelled"
        onClose={() => {}} // No close functionality since it's a blocking modal
      />
    </div>
  );
};

export default DashboardLayout;
